// Need to use the React-specific entry point to import createApi
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../baseQuery';
import { type DocumentRequestModel, type Document } from './documentModels';

export const documentApi = createApi({
  reducerPath: 'documentApi',
  baseQuery: baseQuery('public/documents', true),
  endpoints: (builder) => {
    return {
      getDocuments: builder.query<Document[], DocumentRequestModel>({
        query: ({ famille, produit, reseau, univers_uuid, lang, pays_uuid }) => {
          return {
            url: '',
            method: 'get',
            params: {
              famille,
              produit,
              reseau,
              univers_uuid,
              lang,
              pays_uuid,
            },
          };
        },
      }),

      ////    LastUpdated Docuemnt Type  shuold be defined with actual fields

      getLastUpdatedDocuments: builder.query<Record<string, Document>, DocumentRequestModel>({
        query: ({ lang, univers_uuid, pays_uuid }) => {
          return {
            url: 'lastUpdated',
            method: 'get',
            params: {
              lang,
              univers:univers_uuid,
              pays_uuid,
            },
          };
        },
      }),
    };
  },
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDocumentsQuery, useGetLastUpdatedDocumentsQuery } = documentApi;
